var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.11111,
    y: 1.11111,
    width: 17.7778,
    height: 17.7778,
    rx: 8.88889,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.11111,
    y: 1.11111,
    width: 17.7778,
    height: 17.7778,
    rx: 8.88889,
    stroke: "white",
    strokeWidth: 2.22222
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3867 8.54488C10.0978 8.92266 9.79043 9.33377 9.46451 9.77821C9.13858 10.2227 8.86451 10.6782 8.64228 11.1449H10.3867V8.54488ZM12.009 6.52266V11.1449H12.8312V12.5004H12.009V14.2227H10.3867V12.5004H7.06451V11.2893C7.22747 10.9634 7.43117 10.5967 7.67562 10.1893C7.92006 9.77451 8.19043 9.35229 8.48673 8.92266C8.79043 8.48562 9.10895 8.05969 9.44228 7.64488C9.77562 7.23006 10.109 6.85599 10.4423 6.52266H12.009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle4);
export default __webpack_public_path__ + "static/media/circle_4.393e714c8791955ddf70eaa00f77281c.svg";
export { ForwardRef as ReactComponent };